import { render, staticRenderFns } from "./morderpay.vue?vue&type=template&id=75d2e55c"
import script from "./morderpay.vue?vue&type=script&lang=js"
export * from "./morderpay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports